import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import DailyCronLog from "../DailyCronLog";


function PanelCron() {
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = [
        { "name": "Notification", "path": "/notification" },
        { "name": "Email Reminder", "path": "/email-reminder" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}cron-panel${activeTab?.path}`);
    }, [activeTab]);

    return (
        <div id="cron-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Cron</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "Notification" && <DailyCronLog displayType="Notification" />
                }
                {
                    activeTab?.name == "Email Reminder" && <DailyCronLog displayType="Email Reminder" />
                }

            </div>
        </div>
    );
}

export default PanelCron;